import { createElement, setText } from './dom';
import { historicalSource } from '../history/sources';
import { CERTAINTY, type DiscoveryPlace } from '../discovery/types';

export function discoverySource(
  parent: HTMLElement,
  place: DiscoveryPlace,
  heading: 'h4' | 'h5' = 'h5'
): void {
  const root = createElement('details', 'historical-source', parent);
  const toggle = createElement('summary', 'historical-source-toggle', root);
  setText(toggle, 'How do we know?');
  const body = createElement('div', 'historical-source-note', root);
  setText(createElement('p', 'discovery-certainty', body), CERTAINTY[place.confidence]);
  if (place.source) {
    const source = historicalSource(place.source);
    createElement('cite', 'historical-source-title', body).textContent = source.title;
    createElement('p', 'historical-source-publisher', body).textContent = source.publisher;
    setText(createElement('p', 'historical-source-text', body), source.note.en);
  }
  setText(createElement(heading, 'discovery-sources-title', body), 'Sources of this place');
  const list = createElement('ul', 'discovery-sources', body);
  for (const title of place.sources) createElement('li', '', list).textContent = title;
}
